import React, { Component } from "react";
import { ErrorCode } from "../../../const";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
  Table,
  ControlLabel,
} from "react-bootstrap";

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach((intervalId) => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    const lstInputFiles = fileInfo.input_files
      ? JSON.parse(fileInfo.input_files)
      : [];
    this.state = {
      lstInput: lstInputFiles.map((e) => ({
        input: e.name,
        upload_by: fileInfo.upload_by,
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
        select: false,
      })),
      lstOutput: [],
      failedDownloadsList: [],
      isSelectAllInput: false,
      isSelectAllOutput: false,
      fileInfo: fileInfo,
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED &&
        fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
    };
  }

  listReportWillDelete = null;

  componentDidMount() {
    if (this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED) {
      this.getReportList();
    }
  }

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.CAR,
      this.state.fileInfo.file_name,
    ).then((data) => {
      const lstOutput = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          if (!Business.isOutputFile(item.report_name)) return;
          item.created = Business.convertToFullDate(item.created);
          lstOutput.push(item);
        });
      }

      this.setState({
        lstOutput: lstOutput,
        loading: false,
      });
    });
  };

  onReject = () => {
    this.setState({ showRejectAlert: true });
  };

  onConfirmReject = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.CAR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.REJECTED,
      this.state.reason,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.REJECTED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
              break;
            case ErrorCode.DataInvalid:
              Business.showAlert({
                title: "Error",
                content: res.Data || "Data invalid",
              });
              break;
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onApproval = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.CAR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.APPROVED,
      null,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.APPROVED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
              break;
            case ErrorCode.DataInvalid:
              Business.showAlert({
                title: "Error",
                content: res.Data || "Data invalid",
              });
              break;
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onCalculate = () => {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({
      loading: true,
      errorCode: ErrorCode.PendingBatchProcessing,
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATING,
      ),
    });
    Http.calculate(
      this.state.reportDate,
      this.state.reportName,
      false,
      null,
      null,
      Business.COMPONENT.CAR,
    ).then((res) => {
      this.setState({ loading: false });
      if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        this.onGetBatchResponse();
      } else {
        this.handleCalculateResponse(res);
      }
    });
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstInput.map((item) => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onDownloadInputFiles = () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          const fileInfo = Http.makeDownloadFileInfo(
            item.input,
            this.state.reportDate,
            this.state.reportName,
            "input_calculation",
            Business.COMPONENT.CAR,
          );
          lstFileSelected.push(fileInfo);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      Http.downloadAllFiles(
        lstFileSelected,
        this.state.fileInfo.report_date,
        this.state.fileInfo.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  onDownloadOutputFiles = () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          const fileInfo = Http.makeDownloadFileInfo(
            item.report_name,
            this.state.reportDate,
            this.state.reportName,
            null,
            Business.COMPONENT.CAR,
          );
          lstFileSelected.push(fileInfo);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      Http.downloadAllFiles(
        lstFileSelected,
        this.state.fileInfo.report_date,
        this.state.fileInfo.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName).then(
        (res) => {
          this.handleGetBatchUploadingResponse(res);
        },
      );
    }, 3000);
    lstIntervalId.push(intervalId);
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      ),
    });
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        singleResult: data.SingleResult,
        consolResult: data.ConsolResult,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`,
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn("Received state: BatchEmpty");
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              singleResult: data.SingleResult,
              consolResult: data.ConsolResult,
              status: Business.convertFileStatus(
                Business.ENUMS.FILE_STATUS.CALCULATED,
              ),
            });
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
              paddingTop: "50px",
            }}
            className="title"
          >
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderInputFileManagement = () => {
    return (
      <div>
        <div className="ey-file-table-toolbar">
          <button
            className="ey-dl-icon-btn"
            onClick={() => {
              this.onDownloadInputFiles();
            }}
          >
            <i className="pe-7s-download" />
          </button>
          <span className="ey-file-table-toolbar-label">
            Download selected files
          </span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table ey-file-table">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAllInput === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstInput.map((item, index) => (
                <tr key={item.input}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.input}`}
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td className="ey-file-name">{item.input}</td>
                  <td>{item.upload_by}</td>
                  <td>{item.upload_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderOutputFileManagement = () => {
    return (
      <div>
        <div className="ey-file-table-toolbar">
          <button
            className="ey-dl-icon-btn"
            onClick={() => {
              this.onDownloadOutputFiles();
            }}
          >
            <i className="pe-7s-download" />
          </button>
          <span className="ey-file-table-toolbar-label">
            Download selected files
          </span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table ey-file-table">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectOutput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() => this.onSelectOutput(item.report_name)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td className="ey-file-name">{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderResult = () => {
    const singleResult = this.state.singleResult || {};
    const consolResult = this.state.consolResult || {};
    return (
      <div>
        <div style={{ height: "100px" }} />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Category</th>
              <th>Single</th>
              <th>Consol</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td style={{ fontWeight: "bolder" }}>CAR</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.CAR || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.CAR || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>CET 1</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.CET1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.CET1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>TIER 1</td>
              <td style={{ fontWeight: "bolder" }}>
                {((singleResult.TIER_1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {((consolResult.TIER_1 || 0) * 100).toLocaleString("en-GB")}%
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>Total Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.TOTAL_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.TOTAL_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Common Equity Tier 1 Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(
                  singleResult.COMMON_EQUITY_TIER_1_CAPITAL || 0
                ).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(
                  consolResult.COMMON_EQUITY_TIER_1_CAPITAL || 0
                ).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>Tier 1 Capital</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.TIER_1_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.TIER_1_CAPITAL || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>RWAce</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.RWA_CR || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.RWA_CR || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>RWAccr</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.RWA_CCR || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.RWA_CCR || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>MRC</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.MRC || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.MRC || 0).toLocaleString("en-GB")}
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>ORC</td>
              <td style={{ fontWeight: "bolder" }}>
                {(singleResult.ORC || 0).toLocaleString("en-GB")}
              </td>
              <td style={{ fontWeight: "bolder" }}>
                {(consolResult.ORC || 0).toLocaleString("en-GB")}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">{`${this.state.reportDate || ""} # ${`${this.state.reportName || ""}`.substring("CAR_".length)} # ${this.state.status || ""}`}</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {this.renderInputFileManagement()}

          {(this.state.fileInfo.status ===
            Business.ENUMS.FILE_STATUS.CALCULATED ||
            this.state.lstOutput.length > 0) &&
            this.renderOutputFileManagement()}

          <div>
            <FormGroup controlId="formControlsTextarea">
              <label htmlFor="exampleInputEmail1">Reason for rejection: </label>
              <FormControl
                style={{ height: "100px", resize: "none" }}
                disabled={this.state.isDisableReasonInput}
                componentClass="textarea"
                value={this.state.reason}
                placeholder="Type your reason here..."
                onChange={(event) => {
                  this.setState({ reason: event.target.value });
                }}
              />
            </FormGroup>
            <div style={{ display: "inline" }}>
              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableRejectButton
                }
                className="btn btn-primary"
                style={{
                  backgroundColor: "rgb(255 0 0)",
                  borderColor: "rgb(255 255 255)",
                  borderRadius: "5px",
                  fontWeight: 600,
                  marginLeft: "auto",
                  float: "left",
                  color: "white",
                }}
                onClick={() => {
                  this.onReject();
                }}
              >
                Reject
              </button>
              <div style={{ display: "flex", float: "right" }}>
                <button
                  type="button"
                  disabled={
                    this.state.progressValue > 0 ||
                    this.state.isDisableApprovalButton ||
                    !Business.isHasRole([
                      Business.ROLE_DEFINE_MAP.CAR_APPROVAL_FILES,
                    ])
                  }
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#FFE600",
                    borderColor: "#7F7E82",
                    borderRadius: "5px 0px 0px 5px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    this.onApproval();
                  }}
                >
                  Approval
                </button>
                <button
                  type="button"
                  disabled={
                    this.state.progressValue > 0 ||
                    this.state.isDisableCalculateButton ||
                    !Business.isHasRole([
                      Business.ROLE_DEFINE_MAP.CAR_CALCULATE,
                    ])
                  }
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "rgb(0 255 90)",
                    borderColor: "#7F7E82",
                    borderRadius: "0px 5px 5px 0px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    this.onCalculate();
                  }}
                >
                  Calculate
                </button>
              </div>
            </div>
          </div>

          {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
            this.renderPendingBatchProcessing()}
          {this.state.hasResult && this.renderResult()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => {
            this.onConfirmReject();
          }}
          onCancel={() => {
            this.setState({ showRejectAlert: false });
          }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(", ")}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/CAR/FileManagement/FileInfo.js